import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

export const deleteWarehouse = async (
  scope: RequestScope,
  { id }: { id: number },
  options: WriteRequestOptions
): Promise<EndpointResponse<unknown>> => {
  try {
    const response = await scopedApi(scope).delete<EndpointResponse<unknown>>(`warehouse/${id}`, options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error, { redactRequestData: true });
  }
};
